import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Services";
import CyberRisikoCheck from "./pages/CyberRisikoCheck";
import ServiceModels from "./pages/ServiceModels";
import References from "./pages/References";
import Career from "./pages/Career";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Datenschutz from "./pages/Datenschutz";
import Impressum from "./pages/Impressum";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import FloatingContact from "./components/FloatingContact";
import PerformanceOptimizer from "./components/PerformanceOptimizer";
import Breadcrumb from "./components/Breadcrumb";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PerformanceOptimizer />
        <ScrollToTop />
        <Header />
        <Breadcrumb />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/cyber-risiko-check" element={<CyberRisikoCheck />} />
            <Route path="/service-models" element={<ServiceModels />} />
            <Route path="/references" element={<References />} />
            <Route path="/career" element={<Career />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/impressum" element={<Impressum />} />
          </Routes>
        </main>
        <Footer />
        <FloatingContact />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;